<template>
  <div>
    <v-navigation-drawer
      :expand-on-hover="miniNav && $vuetify.breakpoint.lgAndUp"
      :mini-variant="miniNav && $vuetify.breakpoint.lgAndUp"
      color="primary"
      dark
      app
      overflow
      v-model="drawer"
      v-if="currentUserData.hasOwnProperty('name')"
    >
      <v-list>
        <v-list-item :to="'/userProfile'">
          <v-list-item-avatar>
            <avatar
              v-if="currentUserData.hasOwnProperty('name')"
              :size="35"
              color="white"
              :username="currentUserData.name"
            ></avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ currentUserData.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ currentUserData.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-btn
            text
            style="margin: auto"
            color="red"
            v-if="currentUser"
            @click="$store.dispatch('logout')"
          >
            <v-icon left>mdi-lock-open</v-icon> Logout
          </v-btn>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-item :to="'/'">
          <v-list-item-action>
            <v-icon>mdi-city</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Bases</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/config'">
          <v-list-item-action>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Config</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/loot'">
          <v-list-item-action>
            <v-icon>mdi-bag-personal</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Loot</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/users'">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
<!--      <template v-if="$vuetify.breakpoint.lgAndUp" v-slot:append>-->
<!--        <div class="pl-3 mb-4">-->
<!--          <v-switch-->
<!--            v-model="miniNav"-->
<!--            @change="updateView"-->
<!--            label="Mini Nav"-->
<!--          ></v-switch>-->
<!--        </div>-->
<!--      </template>-->
    </v-navigation-drawer>
    <v-app-bar
      v-if="currentUserData.hasOwnProperty('name') && $vuetify.breakpoint.smAndDown"
      app
      color="primary"
      dark
      :clipped-left="true"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        @click="
          () => {
            if ($route.path !== '/') {
              $router.push('/');
            }
          }
        "
        v-clickable
      >
        End Game
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Avatar from "vue-avatar";

  export default {
    computed: {
      ...mapGetters([
        "siteData",
        "currentUser",
        "currentUserData",
        "navigationDrawer",
      ]),
    },
    data: () => ({
      userMenu: false,
      hints: false,
      message: "",
      fav: false,
      drawer: false,
      clipped: true,
      miniNav: false,
      drawerRoutes: {},
      linkedToGoogle: false,
    }),
    components: {
      Avatar,
    },
    beforeCreate() {},
    mounted() {
      console.log(this.currentUserData);
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false;
        this.$store.dispatch("setNavigationDrawerState", false);
      } else {
        this.drawer = this.navigationDrawer;
      }
    },
    methods: {
      changeNavigationDrawer() {
        this.$store.dispatch("setNavigationDrawerState", !this.drawer);
        this.drawer = !this.drawer;
      },
      resetPassword() {
        console.log(this.currentUser);
        this.$store.dispatch("passwordReset", this.currentUser.email);
        this.$swal({
          title: "Check your inbox",
          text:
            "We've sent you a password reset email. Please follow the instructions to reset your password.",
          type: "success",
          confirmButtonText: "Ok",
        });
        this.forgotPasswordDialog = false;
      },
      linkAccountGoogle() {
        this.$store.dispatch("linkAccountToGoogle").then((result) => {
          if (result == "Success") {
            this.$swal({
              title: "Success!",
              text:
                "Your google account is Linked. You may now sign in with Google",
              type: "success",
              confirmButtonText: "Ok",
            });
            this.linkedToGoogle = true;
          } else {
            this.$swal({
              title: "Failed!",
              text: "This google account was already linked to an Account.",
              type: "error",
              cancelButtonText: "Close",
            });
          }
        });
      },
      updateView() {
        if (this.miniNav == true) {
          this.drawer = false;
          var self = this;
          setTimeout(function () {
            self.drawer = true;
          }, 300);
        }
      },
      appAdminPerms() {
        if (
          this.currentUserData.role == "superAdmin" ||
          this.currentUserData.role == "appAdmin"
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
  };
</script>
